import {XauditModel} from '../xaudit.model';
import {DataPatientCaseWorkItemFormToothModel} from './data-patient-case-work-item-form-tooth.model';

export class DataPatientCaseWorkItemToothModel extends XauditModel {
  CaseWorkItemToothId: string;
  CaseWorkItemId: string;
  ToothID: string;
  Notation: string;

  dataPatientCaseWorkItemFormTooth: DataPatientCaseWorkItemFormToothModel[];
  isSelected: boolean = false;
}
